import Component from '@glimmer/component';

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const ICON_SIZE_CLASSES: Record<Size, string> = {
  xs: 'size-4 min-h-4 min-w-4',
  sm: 'size-5 min-h-5 min-w-5',
  md: 'size-6 min-h-6 min-w-6',
  lg: 'size-8 min-h-8 min-w-8',
  xl: 'size-10 min-h-10 min-w-10',
};

export interface IconSignature {
  Args: {
    name: string;
    size?: Size;
  };
  Element: SVGElement;
}

export default class IconComponent extends Component<IconSignature> {
  get sizeClass() {
    return this.args.size ? ICON_SIZE_CLASSES[this.args.size] : ICON_SIZE_CLASSES['md'];
  }
}
